import React from 'react';
import s from './Dropdown.module.scss';
import Select from 'react-select';

//Common Dropdown for WS project
//Properties
//    Events => onDropdownChange(selectedObject)
//              componentDidMount() //is invoked immediately after a component is mounted (inserted into the tree).
//              componentDidUpdate() //is invoked immediately after updating occurs. This method is not called for the initial render
//              componentWillUnmount() // is invoked immediately before a component is unmounted and destroyed
//              componentDidCatch(error, info) //This lifecycle is invoked after an error has been thrown by a descendant component

const Dropdown = ({
  id,
  dataArray = [],
  controlData = {
    placeholderText: '',
    customClassName: ''
  },
  onDropdownChange = null,
  selectedOption,
  disabled,
  value = {}
}) => {
  // Use default empty object for controlData if it's null or undefined
  const safeControlData = controlData || {
    placeholderText: '',
    customClassName: ''
  };

  return (
    <Select
      id={id}
      placeholder={safeControlData.placeholderText}
      className={`${s.wsaDropdown} ${safeControlData.customClassName}`}
      options={dataArray}
      onChange={onDropdownChange}
      value={selectedOption}
      isDisabled={disabled}
      //defaultValue={defaultValue}
      menuPortalTarget={document.body} // Render menu in document body
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 99999 // High z-index for portal
        })
      }}
    />
  );
};

export default Dropdown;